/* src/app/modules/shared/components/column/column-secondary-price/column-secondary-price.component.scss */
app-column-secondary-price {
  display: contents;
}
/*# sourceMappingURL=column-secondary-price.component.css.map */
